module.exports = __webpack_public_path__ + "static/media/seattlelibrary.0cf892da.jpg";